import {
  useBooleanFlagValue,
  useStringFlagValue,
} from "@openfeature/react-sdk";

import type { FeatureFlagConfiguration } from "./client";
import {
  extractFlagConfig,
  getFlagValue,
  type ExtractVariantType,
} from "./utils";

/**
 * Streamlined hook for feature flags that automatically uses configured default values
 * @param flagConfig - Flag configuration object from FLAGS
 * @returns The flag value with inferred typing
 */
export function useFlag<T extends NonNullable<FeatureFlagConfiguration>>(
  flagConfig: T
): ExtractVariantType<T> {
  const [flagKey, defaultValue] = extractFlagConfig(flagConfig);

  return getFlagValue<ExtractVariantType<T>>(flagKey, defaultValue, {
    boolean: (key, defaultVal) => useBooleanFlagValue(key, defaultVal),
    string: (key, defaultVal) => useStringFlagValue(key, defaultVal),
  });
}
